import PropTypes from 'prop-types';
import React from 'react';
import {
  PanelWrapper,
  PanelHeader,
  PanelBody
} from './index.styles';

const PanelStandard = ({ props }) => {
  const {
    children,
    header,
    headerContent,
    panelBodyStyles,
    panelWrapperStyles,
    errorState,
    completedState
  } = props;

  return (
    <PanelWrapper css={panelWrapperStyles}>
      {(header || headerContent) &&
        <PanelHeader errorState={errorState} completedState={completedState}>
          {(typeof headerContent === 'string') ? <p>{headerContent}</p> : headerContent}
        </PanelHeader>
      }
      <PanelBody css={panelBodyStyles}>{children}</PanelBody>
    </PanelWrapper>
  );
};

PanelStandard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  header: PropTypes.bool,
  headerContent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  panelBodyStyles: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  panelWrapperStyles: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  errorState: PropTypes.bool,
  completedState: PropTypes.bool
};

PanelStandard.defaultProps = {
  children: null,
  header: false,
  headerContent: null,
  panelBodyStyles: null,
  panelWrapperStyles: null,
  errorState: false,
  completedState: false
};

export default PanelStandard;
